import { render } from "./MainTurns.vue?vue&type=template&id=87dfb9e0&scoped=true"
import script from "./MainTurns.vue?vue&type=script&lang=js"
export * from "./MainTurns.vue?vue&type=script&lang=js"

import "./MainTurns.vue?vue&type=style&index=0&id=87dfb9e0&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87dfb9e0"]])

export default __exports__